import { cx, css } from 'emotion';
import {
	purple,
	pink,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	textBlock,
	museo900,
} from 'inside-out/global-styles';

export const wrapperInnerStyle = css({
	display: 'table',
	width: '100%',
	maxWidth: desktopMaxWidthBreakpoint,
	margin: '0 auto',
});

export const topTextStyle = css({
	...museo900,
	margin: '0 0 15px 0',
	color: '#fff',
});

export const bottomTextStyle = cx(
	textBlock,
	css({
		maxWidth: '720px',
		color: '#fff',
	})
);

export const wrapperStyle = inline =>
	cx(
		textBlock,
		css({
			display: 'table',
			width: '100%',
			backgroundColor: purple,
			borderRadius: inline ? '8px' : '',
			padding: inline ? '16px 10px' : '40px 0',
			[`& .${topTextStyle}`]: inline
				? {
						fontSize: '22px',
						fontWeight: 'normal',
				  }
				: {
						fontSize: '36px',
						lineHeight: '36px',
				  },
		})
	);

//wrapperInnerStyle

export const leftStyle = css({
	padding: '20px',
	[`@media (min-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'table-cell',
	},
});

export const rightStyle = css({
	padding: '20px',
	verticalAlign: 'middle',
	[`@media (min-width: ${mobileMaxWidthBreakpoint}px)`]: {
		display: 'table-cell',
	},
});

export const buttonStyle = css({
	...museo900,
	background: pink,
	display: 'block',
	textTransform: 'uppercase',
	color: '#fff',
	fontSize: '16px',
	lineHeight: '1',
	letterSpacing: '0.67px',
	padding: '18px 18px 14px 18px',
	textDecoration: 'none',
	borderRadius: '4px',
	position: 'relative',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		width: '100%',
	},
	textAlign: 'center',
});



// WEBPACK FOOTER //
// ./src/components/shared/inPagePrompt/styles.js